export default __webpack_public_path__ + "static/media/IMG_20200524_154858_627 - 019_ARNAB CHATTERJEE.a31c8b6b.jpg";